<template>

    <div class="page__head container">
        <div class="page__submenu  block">
            <div class="subnav">
                <div class="subnav__item">
                    <a href="/profiles/settings"
                       class="subnav__link link h4"
                       :class="{ 'is-active': settings.name === 'settings' }">Контактные данные</a>
                </div>
                <div class="subnav__item">
                    <a href="/profiles/personal"
                       class="subnav__link  link h4"
                       :class="{ 'is-active': settings.name === 'personal' }">Подключенные ЛС</a>
                </div>
                <div class="subnav__item" v-if="showdeclarers=='true'">
                    <a href="/profiles/declarers"
                       class="subnav__link  link h4"
                       :class="{ 'is-active': settings.name === 'declarers' }">Заявители СТС</a>
                </div>
            </div>
        </div>
        <!--
        <div v-if="settings.isAddAccount" class="page__head-inner block">
        <a href="/profiles/personal" class="page__back link link--crumbs">
            <span class="link__icon icon icon--arrow-left"></span>
            <span class="link__text">Назад</span>
        </a>
        -->

        <!-- Для этой страницы стиль заголвока h2 -->
        <!--
        <h1 class="page__title h2">{{settings.addAccountHeader}}</h1>
        </div>
        -->
    </div>

</template>

<script>

    export default {
		props: {
            settings: {
                type: Object,
                default: function () {
                    return {
                        name: 'settings',
                        isAddAccount: false,
                        addAccountHeader: 'Добавление лицевого сцета'
                    }
                }
            }
            ,
            showdeclarers: { type: String }
        }
        //,
        //props: ['showdeclarers']
        

    }

</script>

<style>
</style>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ProfilesHeader.vue